import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@lib/queryKeys';
import { fetchSupplierInvoiceSummary } from '@/renderer/services/inventorySupplierInvoiceService';

export function useInventorySupplierInvoiceSummary(
  companyId: number | null,
  outletId: string | null | undefined,
  supplierId: string = 'all',
  status: string = 'all',
  dateFrom: string = '',
  dateTo: string = '',
  inventoryItemIds: string[] = [],
) {
  return useQuery({
    queryKey: queryKeys.inventory.supplierInvoiceSummary(
      companyId ?? 0,
      outletId ?? '',
      supplierId,
      status,
      dateFrom,
      dateTo,
      inventoryItemIds,
    ),
    queryFn: async () => {
      const result = await fetchSupplierInvoiceSummary(
        companyId!,
        outletId!,
        supplierId,
        status,
        dateFrom,
        dateTo,
        inventoryItemIds,
      );
      if (!result.success || !result.data) {
        throw new Error(result.error ?? 'Failed to fetch invoice summary');
      }
      return result.data;
    },
    enabled: !!companyId && !!outletId,
  });
}
